var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isTriggers && this.$route.name != 'Login')?_c('v-navigation-drawer',{attrs:{"value":_vm.value,"app":"","right":""},on:{"input":function($event){return _vm.$emit('input', $event)}}},[_c('action-list',{attrs:{"entity":_vm.entity,"noSearch":_vm.noSearch,"title":_vm.title,"data":_vm.data}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }